import namespace from '@/store/namespace'
export default namespace('DocumentosPosteriores', {
  getters: [
    'GetDatosDocsPosterioresPe',
    'GetDocsPosterioresNoEnviadosNet',
    'GetDocsPosterioresEnviadosNet',
    'GetMostrarDetalle'
  ],
  actions: [
    'RegistrarDocPosterior',
    'RegistrarDocPosteriorV2',
    'ModificarDocPosterior',
    'ModificarDocPosteriorV2',
    'EliminarSolicitudDocPosterior',
    'ObtenerDocumentoPosterior',
    'ObtenerDocumentoPosteriorV2',
    'ObtenerDocsPosterioresNoEnviadosNet',
    'ObtenerDocsPosterioresEnviadosNet',
    'EnviarSolicitudDocPosterior',
    'ObtenerDocumentoBorrador'
  ],
  mutations: [
    'SetDatosDocsPosterioresPe',
    'SetDocsPosterioresNoEnviadosNet',
    'SetDocsPosterioresEnviadosNet',
    'SetMostrarDetalle'
  ]
})
